// Organization Action Types
export const GET_ORGANIZATIONS = "GET_ORGANIZATIONS";
export const ADD_ORGANIZATION = "ADD_ORGANIZATION";
export const UPDATE_ORGANIZATION = "UPDATE_ORGANIZATION";
export const DELETE_ORGANIZATION = "DELETE_ORGANIZATION";
export const SELECT_ORGANIZATION = "SELECT_ORGANIZATION";
export const TOGGLE_ORGANIZATION_STATUS = "TOGGLE_ORGANIZATION_STATUS";

// Organization Profile
export const GET_ORG_PROFILE = "GET_ORG_PROFILE";
export const UPDATE_ORG_PROFILE = "UPDATE_ORG_PROFILE";
export const RESET_PASSWORD = "RESET_PASSWORD";
